import { SubscriptionType } from "../const";
import { Instalation } from "./Instalation";
import { MachineStatus } from "./MachineStatus";


export class Machine {
    idmachine: number;
    serial_number: string;
    name: string;
    v_firmware_io: string;
    v_firmware_hmi: string;
    hmi_mac: string;
    v_date: Date;
    v_release_date: Date;
    token: string;
    model: string;
    type: number;
    active: boolean;
    createdAt: Date;
    last_conection: Date;
    instalation: Instalation;
    machine_status: MachineStatus[];
    usageHours: number;
    consumption: number;
    speed: number;
    flow: number;
    humiditySetPoint: number;
    temperatureSetPoint: number;
    machineState: boolean;
    licenseState: number;
    expDate: Date;

    constructor() {
        // Asigna valores por defecto a las propiedades
        this.idmachine = 0;
        this.serial_number = '';
        this.name = '';
        this.v_firmware_io = '';
        this.v_firmware_hmi = '';
        this.hmi_mac = '';
        this.v_date = new Date();
        this.v_release_date = new Date();
        this.token = '';
        this.model = '';
        this.active = true;
        this.type = 0;
        this.createdAt = new Date();
        this.last_conection = new Date();
        this.instalation = new Instalation();
        this.machine_status = [];
        this.usageHours = 0
        this.consumption = 0
        this.speed = 0
        this.flow = 0
        this.humiditySetPoint = 0;
        this.temperatureSetPoint = 0;
        this.machineState = true
        this.licenseState = SubscriptionType.Inactive
        this.expDate = new Date();

    }
}